import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Traders = _resolveComponent("Traders")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Traders, { type: "providers" })
          ])
        ])
      ]),
      _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512)
    ]),
    _: 1
  }, 512))
}